import React, { use, useEffect, useState } from "react";
import styles from "./ScholarshipFundAllocation.module.scss";
import {
  Box,
  TextField,
  Typography,
  Button,
  MenuItem,
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Container,
  Divider,
  FormControlLabel,
} from "@mui/material";
import { useFormik, FieldArray, FormikProvider, getIn } from "formik";
import {
  FundAllocationValues,
  ScholarshipSummaryFund,
  ScholarshipSummaryType,
} from "../../../types/types";
import { FundAllocationSchema } from "../../../forms/FundAllocationValidation";
import { InitialValuesFundAllocation } from "../../../types/formTypes";
import { FrequenciesFunds } from "../../../data/alldata";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { addFundallowItem } from "../../../redux/actions/Actions";
import { useNavigate } from "react-router-dom";
import { Switch } from "@mui/material";
import { useGet } from "../../../services/hooks/useGet";
import { GetUrl, PatchUrl } from "../../../api/endpointConfig";
import { useLoader } from "../../../Loader/LoaderContext";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { ToastService } from "../../../utils/toastService";
import { isEqual } from "lodash";


const ScholarshipFundAllocation = () => {
  const [mainData, setMainData] = useState<ScholarshipSummaryFund[]>([]);
  const [disableStatus, setDisableStatus] = useState<boolean>(false);
  const [allPurpose, setAllPurpose] = useState<any>([]);
  const scholarshipSummaryArr = useSelector(
    (state: RootState) => state.app.ScholarshipSummaryDetails
  );
  const applicationDetails = useSelector(
    (state: RootState) => state.app.fundAllocationDetails
  );
  const user = JSON.parse(localStorage.getItem("userData") || "{}");
  const userRole: any = user?.role;
  const { showLoader, hideLoader } = useLoader();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getScholarshipData = useGet<any>(
    `${GetUrl.getScholarshipSummary}/${scholarshipSummaryArr[0]?.id}`
  );

  useEffect(() => {
    if (userRole === "Admin") {
      setDisableStatus(false);
    } else {
      setDisableStatus(false);
    }
  }, [userRole]);

  const fetchSummaryData = async () => {
    showLoader();
    try {
      const result = await getScholarshipData.refetch();
      hideLoader();
      if (result?.data) {
        setMainData([result.data]);
      }
    } catch (error) {
      hideLoader();
      console.error("Error fetching app version:", error);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchSummaryData();
  }, []);

  const formik = useFormik({
    initialValues: InitialValuesFundAllocation,
    validationSchema: FundAllocationSchema,
    onSubmit: (values) => {
      console.log("Submitted:", values);
      handleSubmit();
    },
  });
  const handleFieldChange = (
    index: number,
    field: "allocationAmount" | "installments",
    value: string
  ) => {
    const parsedValue = parseInt(value) || 0;

    const current = formik.values.funds[index];
    const updated = {
      ...current,
      [field]: parsedValue,
    };

    const allocation =
      field === "allocationAmount" ? parsedValue : current.allocationAmount;
    const installments =
      field === "installments" ? parsedValue : current.installments;

    const calculatedTotal = Number(allocation) * Number(installments);

    formik.setFieldValue(`funds[${index}].${field}`, parsedValue);
    formik.setFieldValue(`funds[${index}].totalAmount`, calculatedTotal);
  };
  const grandTotal = formik.values.funds.reduce(
    (acc, row) => acc + (Number(row.totalAmount) || 0),
    0
  );
  const formatToMMDDYYYY = (isoDate: string): string => {
    if (!isoDate) return "";

    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return ""; // invalid date

    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  };
  useEffect(() => {
    // if (scholarshipSummaryArr[0]?.status === "approved") {
    console.log("mainData", mainData[0]?.fund_allocated);
    formik.setFieldValue(`startDate`, mainData[0]?.start_date);
    formik.setFieldValue(`endDate`, mainData[0]?.end_date);
    formik.setFieldValue(`firstpaymentdate`, mainData[0]?.first_payment_dt);
    formik.setFieldValue(`firstpayment`, mainData[0]?.first_payment_amt);
    mainData[0]?.fund_allocated.map((item, index) => {
      return (
        formik.setFieldValue(`funds.[${index}].id`, item.id),
        formik.setFieldValue(`funds.[${index}].purpose`, item.purpose),
        formik.setFieldValue(
          `funds.[${index}].allocationAmount`,
          item.allocation_amount
        ),
        formik.setFieldValue(`funds.[${index}].frequency`, item.frequency),
        formik.setFieldValue(
          `funds.[${index}].installments`,
          item.no_of_installment
        ),
        formik.setFieldValue(`funds.[${index}].totalAmount`, item.total_amt),
        formik.setFieldValue(`funds.[${index}].is_disabled`, item.is_disabled || false)
        
      );
    });
    formik.setFieldValue(
      `firstpaymentpurpose`,
      mainData[0]?.first_payment_purpose
    );
    // }
  }, [mainData]);
  const convertToISODate = (input: string) => {
    const year = input.slice(0, 4);
    const month = input.slice(4, 6);
    const day = input.slice(6, 8);

    const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
    return date;
  };
  const updateScholarship = useMutationByMethod<any>(
    "patch",
    `${PatchUrl.updateScholarshipFund}/${scholarshipSummaryArr[0]?.id}`
  );
  const fundallocation = formik.values.funds.map((item) => ({
    id: item.id || 0,
    purpose: item.purpose,
    allocation_amount: item.allocationAmount,
    frequency: item.frequency,
    no_of_installment: item.installments,
    total_amt: item.totalAmount,
    is_disabled: item.is_disabled || false,
  }));

  // Step 2: Normalize existing backend data to match Formik shape
  const existingAllocation = (mainData[0]?.fund_allocated || []).map(
    (item) => ({
      id: item.id || 0,
      purpose: item.purpose,
      allocation_amount: item.allocation_amount,
      frequency: item.frequency,
      no_of_installment: item.no_of_installment,
      total_amt: item.total_amt,
    })
  );
  useEffect(() => {
    if (isEqual(fundallocation, existingAllocation)) {
      console.log("No changes in fund allocation.");
      setAllPurpose(existingAllocation);
    } else {
      console.log("Fund allocation has been modified.");
      setAllPurpose(fundallocation);
    }
  }, [mainData, formik.values]);
  const updateFundAllocationReq = async () => {
    // Step 3: Construct the object conditionally
    const obj: any = {
      fund_allocation: isEqual(fundallocation, existingAllocation)
        ? []
        : fundallocation,
      grand_total: grandTotal,
      first_payment_dt: formik.values.firstpaymentdate
        ? convertToISODate(formik.values.firstpaymentdate as any)
        : null,
      first_payment_amt: formik.values.firstpayment
        ? formik.values.firstpayment
        : null,
      coordinator: null,
      first_payment_purpose: formik.values.firstpaymentpurpose
        ? formik.values.firstpaymentpurpose
        : null,
    };
    if (mainData[0]?.end_date !== formik.values.endDate) {
      obj.scholarship_end_dt = convertToISODate(formik.values.endDate);
    }

    updateScholarship.mutate(obj, {
      onSuccess: (data) => {
        console.log("data", data);
        ToastService.success(
          "The scholarship fuld has been allocated successfully."
        );
        setTimeout(() => {
          navigate(-1);
        }, 4000);
      },
      onError: (err) => {
        console.error("error", err);
      },
    });
  };

  const handleSubmit = () => {
    updateFundAllocationReq();
  };
  return (
    <>
      <Container className={styles.container}>
        <Box className={styles.header}>
          <Typography variant="h5" className={styles.title}>
            Fund Allocation Details
          </Typography>
          {/* <Box className={styles.navigationButtons}>
            <Button
              variant="contained"
              className={styles.saveButton}
              onClick={() => formik.handleSubmit()}
            >
              Submit
            </Button>
          </Box> */}
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          paddingBottom={2}
        >
          <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Student Name: </Typography>
            <Typography fontWeight={"bold"}>
              {scholarshipSummaryArr[0]?.name}
            </Typography>
          </Box>
          {/* <Box p={0} display={"flex"} alignItems={"center"}>
            <Typography>Scholarship ID: </Typography>
            <Typography fontWeight={"bold"}>SRBF2022/01</Typography>
          </Box> */}
        </Box>
        <Divider sx={{ marginBottom: 3 }} />
        <form onSubmit={formik.handleSubmit} className="form-group">
          <Box className={styles.educationSection}>
            <Box className={styles.fieldRow}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Scholarship Start Date *"
                    views={["year", "month", "day"]}
                    format="DD/MM/YYYY"
                    value={
                      formik.values.startDate
                        ? dayjs(formik.values.startDate, "YYYYMMDD")
                        : null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        "startDate",
                        date && date.isValid() ? date.format("YYYYMMDD") : ""
                      );
                      // Optional: Reset endDate if it's earlier than new startDate
                      if (
                        date &&
                        date.isValid() &&
                        formik.values.endDate &&
                        dayjs(formik.values.endDate, "YYYYMMDD").isBefore(date)
                      ) {
                        formik.setFieldValue("endDate", "");
                      }
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error:
                          formik.touched.startDate &&
                          Boolean(formik.errors.startDate),
                        helperText: formik.touched.startDate
                          ? formik.errors.startDate
                          : "",
                        InputLabelProps: { shrink: true },
                        className: styles.textFourField,
                      },
                    }}
                    disabled={disableStatus}
                  />
                </DemoContainer>
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Scholarship End Date *"
                    views={["year", "month", "day"]}
                    format="DD/MM/YYYY"
                    minDate={
                      formik.values.startDate
                        ? dayjs(formik.values.startDate, "YYYYMMDD")
                        : undefined
                    }
                    value={
                      formik.values.endDate
                        ? dayjs(formik.values.endDate, "YYYYMMDD")
                        : null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        "endDate",
                        date && date.isValid() ? date.format("YYYYMMDD") : ""
                      );
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error:
                          formik.touched.endDate &&
                          Boolean(formik.errors.endDate),
                        helperText: formik.touched.endDate
                          ? formik.errors.endDate
                          : "",
                        InputLabelProps: { shrink: true },
                        className: styles.textFourField,
                      },
                    }}
                    disabled={disableStatus }
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>

            <FormikProvider value={formik}>
              <FieldArray name="funds">
                {({ push, remove }) => (
                  <Box>
                    {formik.values.funds.map((fundItem, index) => (
                      <Accordion
                        key={index}
                        defaultExpanded
                        className={styles.accordion}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            variant="subtitle1"
                            className="accrodionHeading"
                          >
                            {/* Fund {index + 1} */}
                            {fundItem.purpose
                              ? fundItem.purpose
                              : `Fund ${index + 1}`}{" "}
                            {fundItem.totalAmount &&
                              `-₹ ${fundItem.totalAmount}`}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box
                            className={`${styles.fieldRow} ${styles.fieldRowOth}`}
                          >
                            <TextField
                              fullWidth
                              id={`funds[${index}].purpose`}
                              name={`funds[${index}].purpose`}
                              label="Purpose *"
                              value={fundItem.purpose ?? ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.purpose &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)?.purpose
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.purpose &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)?.purpose
                              }
                              className={styles.textFourField}
                              disabled={disableStatus || fundItem.is_disabled}
                            />

                            <TextField
                              fullWidth
                              id={`funds[${index}].allocationAmount`}
                              name={`funds[${index}].allocationAmount`}
                              label="Allocation Amount *"
                              value={fundItem.allocationAmount ?? ""}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "allocationAmount",
                                  e.target.value
                                )
                              }
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]
                                  ?.allocationAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.allocationAmount
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]
                                  ?.allocationAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)
                                  ?.allocationAmount
                              }
                              className={styles.textFourField}
                              disabled={disableStatus || fundItem.is_disabled}
                            />

                            <TextField
                              fullWidth
                              id={`funds[${index}].frequency`}
                              name={`funds[${index}].frequency`}
                              label="Frequency *"
                              select
                              value={fundItem.frequency ?? ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.frequency &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.frequency
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.frequency &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)?.frequency
                              }
                              className={styles.textFourField}
                              disabled={disableStatus || fundItem.is_disabled}
                            >
                              <MenuItem value="">Select Frequency</MenuItem>
                              {FrequenciesFunds.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </TextField>
                            <TextField
                              fullWidth
                              id={`funds[${index}].installments`}
                              name={`funds[${index}].installments`}
                              label="No of Installments *"
                              value={fundItem.installments ?? ""}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "installments",
                                  e.target.value
                                )
                              }
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.installments &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.installments
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.installments &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)
                                  ?.installments
                              }
                              className={styles.textFourField}
                              disabled={disableStatus || fundItem.is_disabled}
                            />

                            <TextField
                              fullWidth
                              id={`funds[${index}].totalAmount`}
                              name={`funds[${index}].totalAmount`}
                              label="Total Amount *"
                              value={fundItem.totalAmount ?? ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.funds?.[index]?.totalAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                Boolean(
                                  (formik.errors.funds?.[index] as any)
                                    ?.totalAmount
                                )
                              }
                              helperText={
                                formik.touched.funds?.[index]?.totalAmount &&
                                typeof formik.errors.funds?.[index] !==
                                  "string" &&
                                (formik.errors.funds?.[index] as any)
                                  ?.totalAmount
                              }
                              className={styles.textFourField}
                              disabled={disableStatus || fundItem.is_disabled}
                            />
                          </Box>

                          {(formik.values.funds.length > 1 && !formik.values.funds[index].id) && (
                            <Button
                              startIcon={<RemoveCircleOutlineIcon />}
                              color="error"
                              onClick={() => remove(index)}
                              className={styles.removeButton}
                              disabled={disableStatus || formik.values.funds[index].is_disabled}
                            >
                              Remove
                            </Button>
                          )}
                          {( formik.values.funds[index].id) && (
                             <>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={fundItem.is_disabled || false}
                                    onChange={() => {
                                      const funds = formik.values.funds;

                                      // Count active funds
                                      const activeFunds = funds.filter(f => !f.is_disabled);

                                      // If only one active fund left and user is trying to disable it
                                      if (activeFunds.length === 1 && !fundItem.is_disabled) {
                                        ToastService.error("At least one active fund must remain. If you want to disable this fund, please add a new row first.");
                                        return;
                                      }

                                      formik.setFieldValue(
                                        `funds[${index}].is_disabled`,
                                        !fundItem.is_disabled
                                      );
                                    }}
                                    color="primary"
                                  />
                                }
                                label="Disable Fund"
                              />
                             </>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    ))}
                    <Box
                      padding={2}
                      display={"flex"}
                      justifyContent={"flex-end"}
                    >
                      <Button
                        startIcon={<AddCircleOutlineIcon />}
                        variant="contained"
                        onClick={() =>
                          push({
                            purpose: "",
                            allocationAmount: "",
                            frequency: "",
                            installments: "",
                            totalAmount: "",
                          })
                        }
                        className={styles.commonBtn}
                        disabled={disableStatus}
                      >
                        Add More Fund
                      </Button>
                    </Box>
                    {formik.touched.funds &&
                      typeof formik.errors.funds === "string" && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{ mt: 1 }}
                        >
                          {formik.errors.funds}
                        </Typography>
                      )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
            {/* {(mainData[0]?.first_payment_amt || mainData[0]?.first_payment_dt) ? null : (
              <> */}
            <Box mt={2}>
              <Typography variant="h6" className={styles.firstPaymentTitle}>
                First Payment Details
              </Typography>
            </Box>
            <Box mb={2} className={`${styles.fieldRow} ${styles.fieldRowOth}`}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="First Payment Date"
                    views={["year", "month", "day"]}
                    format="DD/MM/YYYY"
                    value={
                      formik.values.firstpaymentdate
                        ? dayjs(formik.values.firstpaymentdate, "YYYYMMDD")
                        : null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        "firstpaymentdate",
                        date && date.isValid() ? date.format("YYYYMMDD") : ""
                      );
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error:
                          (formik.touched?.firstpaymentdate ||
                            formik.submitCount > 0) &&
                          typeof formik.errors !== "string" &&
                          Boolean((formik.errors as any)?.firstpaymentdate),
                        helperText:
                          (formik.touched?.firstpaymentdate ||
                            formik.submitCount > 0) &&
                          typeof formik.errors !== "string" &&
                          (formik.errors as any)?.firstpaymentdate,
                        InputLabelProps: { shrink: true },
                        className: styles.textFourField,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>

              <TextField
                id="firstpayment"
                name="firstpayment"
                label="First Payment"
                type="number"
                value={formik.values.firstpayment ?? ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.firstpayment &&
                  Boolean(formik.errors.firstpayment)
                }
                helperText={
                  formik.touched.firstpayment && formik.errors.firstpayment
                }
                className={styles.textNoneField}
              />
              {allPurpose?.length > 0 && (
              <TextField
                fullWidth
                id={`firstpaymentpurpose`}
                name={`firstpaymentpurpose`}
                label="Purpose of First Payment"
                select
                value={formik.values.firstpaymentpurpose ?? ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.firstpaymentpurpose &&
                  typeof formik.errors.firstpaymentpurpose !== "string" &&
                  Boolean((formik.errors.firstpaymentpurpose as any)?.frequency)
                }
                helperText={
                  formik.touched.firstpaymentpurpose &&
                  typeof formik.errors.firstpaymentpurpose !== "string" &&
                  (formik.errors.firstpaymentpurpose as any)?.frequency
                }
                className={styles.textAutoField}
              >
                <MenuItem value="">Select Purpose</MenuItem>
                {allPurpose && allPurpose?.map((item: any, index: number) => (
                  <MenuItem key={index} value={item.purpose}>
                    {item.purpose}
                  </MenuItem>
                ))}
              </TextField>
              )}
            </Box>
            {/* </>
            )} */}
          </Box>
        </form>
        <Box>
          <Typography variant="h6">
            Grand Total: ₹ <strong>{grandTotal}</strong>
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          className={styles.btnsPanel}
        >
          <Button
            variant="contained"
            className={styles.backButton}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            className={styles.saveButton}
            onClick={() => formik.handleSubmit()}
            disabled={scholarshipSummaryArr[0]?.status === "approved"}
          >
            Save
          </Button>
        </Box>
      </Container>
    </>
  );
};
export default ScholarshipFundAllocation;
